import {DceJsx, DceJsxRenderer} from "dce-jsx";
import {ToolbarItem} from "./ToolbarItem";
import {ToolbarGroup} from "./ToolbarGroup";
import {Editor} from "@tiptap/core";
import {Transaction} from "prosemirror-state";

export default class Toolbar extends DceJsxRenderer {

    private items: ToolbarItem[] = [];
    private groups: ToolbarGroup[] = [];

    public addGroup(...items:ToolbarItem[]){
        this.items.push(...items);

        this.groups.push(
            new ToolbarGroup(items)
        );
    }

    public mount(editor: Editor){
        this.items.forEach(i => i.mount(editor));
    }

    public consumeTransaction(editor: Editor, transaction: Transaction){
        this.items.forEach(i => i.consumeTransaction(editor, transaction));
    }

    render(): JSX.Element {
        return (
            <div className={"tiptap-editor-toolbar"}>
                {
                    this.groups.map(i => {
                        return i.generateElement();
                    })
                }
            </div>
        );
    }

}